import { defaultFormState, FormState } from './Form';
import { RPCErrorDetails } from './rpc';
import { text } from './text';

export interface VerifyResponse {
    hostname: string | null;
}

export interface State {
    form: FormState;
    phase: 'loading' | 'input' | 'submitting' | 'done';
    hostError?: string;
    inUse: string[];
    error?: RPCErrorDetails;
}

const template: State = {
    form: defaultFormState(),
    phase: 'input',
    inUse: [],
};

const testStates: { [key: string]: State } = {
    thanks: { ...template, phase: 'done' },
    error: { ...template, error: text.testError },
    dup: {
        ...template,
        form: { ...template.form, host: 'duplicate' },
        inUse: ['duplicate'],
    },
};

export const defaultState: State = testStates[
    document.location.hash.substr(1)
] || { ...template, phase: 'loading' };
